"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
class GeoBoundingBoxFilterClass {
    constructor(config) {
        this.config = config;
    }
    getLabel() {
        return this.config.label;
    }
    getIdentifier() {
        return this.config.identifier;
    }
    getFilters(filters) {
        return {
            geo_bounding_box: {
                [this.config.field]: lodash_1.omitBy({
                    top_left: filters[0].geoBoundingBox.topLeft,
                    bottom_right: filters[0].geoBoundingBox.bottomRight,
                    bottom_left: filters[0].geoBoundingBox.bottomLeft,
                    top_right: filters[0].geoBoundingBox.topRight
                }, lodash_1.isNil)
            }
        };
    }
    getSelectedFilter(filterSet) {
        const c = filterSet.geoBoundingBox;
        return {
            type: 'GeoBoundingBoxSelectedFilter',
            id: `${this.getIdentifier()}_${JSON.stringify(c)}`,
            identifier: this.getIdentifier(),
            label: this.getLabel(),
            topLeft: c.topLeft,
            bottomRight: c.bottomRight,
            display: this.config.display || 'GeoBoundingBoxFilter'
        };
    }
}
exports.default = GeoBoundingBoxFilterClass;
